import { QueryFactory } from "../../../../Common";
export const QGetTournamentDetails = QueryFactory("GetTournamentDetails");
//# sourceMappingURL=QGetTournamentDetails.js.map